@if (contactDetails.phone) {
  <ng-container i18n="Contact details phone@@3262236020277300799">Phone</ng-container>:
  <a kb-link [href]="'tel:'+contactDetails.phone" appTrackClick="Contact Details: phone">{{ contactDetails.phone }}</a>
  @if (footnotes.has(footnoteType.Phone)) {
    <sup>&nbsp;{{ footnotes.get(footnoteType.Phone)!.index }}</sup>
  }
  <br>
}
@if (contactDetails.cellphone) {
  <ng-container i18n="Contact details cellphone@@5120311954609721042">Cellphone</ng-container>:
  <a kb-link [href]="'tel:'+contactDetails.cellphone" appTrackClick="Contact Details: cellphone">{{ contactDetails.cellphone }}</a>
  @if (footnotes.has(footnoteType.Cellphone)) {
    <sup>&nbsp;{{ footnotes.get(footnoteType.Cellphone)!.index }}</sup>
  }
  <br>
}
@if (contactDetails.fax) {
  <ng-container i18n="Contact details fax@@791988267498679324">Fax</ng-container>:
  <a kb-link [href]="'tel:'+contactDetails.fax" appTrackClick="Contact Details: fax">{{contactDetails.fax}}</a>
  @if (footnotes.has(footnoteType.Fax)) {
    <sup>&nbsp;{{ footnotes.get(footnoteType.Fax)!.index }}</sup>
  }
  <br>
}
@if (contactDetails.email) {
  <a kb-link [href]="'mailto:'+contactDetails.email" appTrackClick="Contact Details: email">{{contactDetails.email}}</a><br>
}
@if (contactDetails.website) {
  <a kb-link [href]="contactDetails.website" target="_blank" appTrackClick="Contact Details: website">{{contactDetails.website}}</a>
}
@if (hasFootnotes()) {
  <p class="footnotes" kb-paragraph>
    <br>
    @if (footnotes.has(footnoteType.Phone)) {
      <sup>{{ footnotes.get(footnoteType.Phone)!.index }}</sup> {{ contactDetails.phoneFootnote }}
      <br>
    }
    @if (footnotes.has(footnoteType.Cellphone) && !footnotes.get(footnoteType.Cellphone)!.duplicate) {
      <sup>{{ footnotes.get(footnoteType.Cellphone)!.index }}</sup> {{contactDetails.cellphoneFootnote}}
      <br>
    }
    @if (footnotes.has(footnoteType.Fax) && !footnotes.get(footnoteType.Fax)!.duplicate) {
      <sup>{{ footnotes.get(footnoteType.Fax)!.index }}</sup> {{contactDetails.faxFootnote}}
    }
  </p>
}
